"use client";

import loadingAnimation from "../lottie/loading-airplane.json";
import { LazyLottie } from "../ui/lazy-lottie";
import { useLoadingStore } from "@erp/shared-libs/stores";

export const LoadingProvider = () => {
  const { loadingEntities } = useLoadingStore();

  return (
    <div
      className={`z-9998 backdrop-blur-xs grid h-screen w-screen place-content-center bg-white/10 dark:bg-black/40
        ${loadingEntities.size > 0 ? "fixed" : "hidden"}`}
    >
      <div className="flex h-40 w-40 flex-col items-center justify-center">
        <LazyLottie animationData={loadingAnimation} loop autoplay />
      </div>
    </div>
  );
};
